import { render, staticRenderFns } from "./backOn.vue?vue&type=template&id=38d65682&"
import script from "./backOn.vue?vue&type=script&lang=ts&"
export * from "./backOn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports